import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { GeneralService } from 'src/app/core/services/general/general.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
declare var ResizeObserver: any;

@Component({
  selector: 'app-cursos',
  templateUrl: './cursos.component.html',
  styleUrls: ['./cursos.component.scss'],

})
export class CursosComponent implements OnInit {

  botones = []
  pathMob = ''
  path = ''
  language: any;
  venue: any;
  carrer: any;
  datos: any;
  cuotas = [];
  sedeDeInteres = '';
  svgContent: SafeHtml | null = null;
  visibleFaqs: boolean[] = [];
  isDesktop = window.innerWidth > 767;
  @ViewChild('container') container!: ElementRef;
  imagesSlider: any[] = [];


  constructor(private sanitizer: DomSanitizer,
    public route: ActivatedRoute,
    private service: GeneralService,
    private router: Router,
    public dialog: MatDialog, private http: HttpClient) {
    this.route.params.forEach((params: Params) => {
      this.language = params['language'];
    })
    this.route.params.forEach((params: Params) => {
      this.venue = params['venue'];
    })

    this.route.params.forEach((params: Params) => {
      this.carrer = params['carrer'];
    });
    this.service.getCarrerByTitle(this.carrer, this.venue, this.language).subscribe(res => {
      this.datos = res.data[0]
      //slider
      this.datos.general_data_obj?.slider.forEach(img => {
        if (img.state) {
          this.imagesSlider.unshift({
            path: img.image_uri,
            pathMobile: img.image_mobile_uri,
            redirect: img.redirect,
            id: img.identifier
          });
        }

      })

      //studyPlanItems
      this.datos.studyPlanItems?.forEach(d => {
        d.html = this.getSafeHtml(d.body);
      })

      if (this.datos.form_hubspot) {
        this.agregarParametro(res.data[0])
      }
      const safeIframeHtml: SafeHtml = this.sanitizer.bypassSecurityTrustHtml(this.datos.general_data);
      this.datos.general_data = safeIframeHtml;
      this.datos.cuotas.forEach(c => {
        let valorCuota = (this.datos.arancel) / c.cant_cuotas;
        this.cuotas.push({ cant: c.cant_cuotas, interes: c.interes, valor: valorCuota })
      })
    })

  }


  getSafeHtml(body) {
    return this.sanitizer.bypassSecurityTrustHtml(body);
  }
  agregarParametro(data) {
    console.log(data)
    let regionFormateada = '';
    let region = '';
    let areaFormateada = '';
    let area_tematica = '';
    if (data.region) {
      region = (data.region[0].title)
      regionFormateada = this.quitarTildes(data.region[0].title.toLowerCase().replace(/\s+/g, '_'));
    }
    if (data.area && data.area[0]) {
      area_tematica = data.area[0]?.name;
      areaFormateada = this.quitarTildes(data.area[0]?.name.toLowerCase().replace(/\s+/g, '_'));
    }
    const queryParams: { [key: string]: any } = {};
    queryParams[`sede_de_interes_posgrado`] = region;
    queryParams[`area_de_interes`] = area_tematica;
    queryParams[`carrera_de_posgrado__${areaFormateada}_`] = data.title;
    
    console.log(queryParams)

    this.router
      .navigate([], {
        relativeTo: this.route,
        queryParams: queryParams,
        queryParamsHandling: 'merge',
      });
  }

  quitarTildes(texto: string) {
    const tildes = {
      á: 'a',
      é: 'e',
      í: 'i',
      ó: 'o',
      ú: 'u',
      ü: 'u',
      Á: 'A',
      É: 'E',
      Í: 'I',
      Ó: 'O',
      Ú: 'U',
      Ü: 'U',
    };

    return texto.replace(/[áéíóúüÁÉÍÓÚÜ]/g, letra => tildes[letra]);
  }
  ngOnInit(): void {
    this.checkStyles();
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.isDesktop = (event.target as Window).innerWidth > 767;
    this.checkStyles();
  }
  resizeObserver: any;
  ignoreNextResize = false;

  ngAfterViewInit(): void {
    if (this.container?.nativeElement) {
      this.resizeObserver = new ResizeObserver(() => {
        if (this.ignoreNextResize) {
          this.ignoreNextResize = false;
          return;
        }
        this.checkStyles();
      });
      this.resizeObserver.observe(this.container.nativeElement);
    }
  }
  checkStyles() {

  }

  open(index: any) {
    this.visibleFaqs[index] = !this.visibleFaqs[index];
  }
  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
  }

  getHalfLength(): number {
    const len = this.datos.general_data_obj?.faqs?.length || 0;
    return Math.ceil(len / 2);
  }
}
